module.exports = __webpack_public_path__ + "img/06.90dc2d14.png";